'use strict';

export default class AddUserController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.newUser = {};
  }

  save() {
    this.$http.post(`/api/betaGroups/${this.$stateParams.id}/adduser`, this.newUser).then(res => {
      this.$state.go('betagroups.show', {id: this.$stateParams.id});
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/betagroups/adduser/adduser.controller.js